import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import mixpanel from 'mixpanel-browser';
import React, { StrictMode } from 'react';
import { persistor, store } from './store';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';

import './index.css';
import styled from '@emotion/styled';

import App from './App';
import { AuthProvider } from './hooks/useAuth';
import { ThemeToggleProvider } from './hooks/useThemeToggle';
import { NonAccountantModeProvider } from './hooks/useNonAccountantMode';

const root = ReactDOM.createRoot(document.getElementById('root'));
const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent-success': {
        backgroundColor: '#36873D',
    },
    '&.notistack-MuiContent-error': {
        backgroundColor: '#B62916',
    },
}));

mixpanel.init(process.env.MIX_PANEL_ID);

root.render(
    <StrictMode>
        <BrowserRouter>
            <SnackbarProvider
                maxSnack={1}
                style={{
                    fontFamily: 'Inter',
                }}
                Components={{
                    success: StyledMaterialDesignContent,
                    error: StyledMaterialDesignContent,
                }}
            >
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <AuthProvider>
                            <NonAccountantModeProvider>
                                <ThemeToggleProvider>
                                    <App />
                                </ThemeToggleProvider>
                            </NonAccountantModeProvider>
                        </AuthProvider>
                    </PersistGate>
                </Provider>
            </SnackbarProvider>
        </BrowserRouter>
    </StrictMode>,
);
